import { jsx as C } from "react/jsx-runtime";
function t(r) {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "15",
      height: "19",
      viewBox: "0 0 15 19",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M13.3333 10.8333C13.3333 10.0582 13.1823 9.3202 12.9093 8.64583C12.7066 8.14503 12.2557 7.44512 11.6374 6.63736C11.0308 5.84502 10.3056 5.00262 9.60286 4.22688C8.90141 3.45256 8.22903 2.75222 7.73193 2.24527C7.64979 2.1615 7.57182 2.08346 7.5 2.0109C7.42818 2.08346 7.35021 2.1615 7.26807 2.24527C6.77097 2.75222 6.09859 3.45256 5.39714 4.22688C4.6944 5.00262 3.96918 5.84502 3.36263 6.63736C2.74429 7.44512 2.29343 8.14503 2.09066 8.64583C1.81768 9.3202 1.66667 10.0582 1.66667 10.8333C1.66667 14.055 4.27834 16.6667 7.5 16.6667C10.7217 16.6667 13.3333 14.055 13.3333 10.8333ZM15 10.8333C15 14.9755 11.6421 18.3333 7.5 18.3333C3.35786 18.3333 0 14.9755 0 10.8333C0 9.84035 0.19327 8.89044 0.545247 8.02083C0.836999 7.30008 1.40604 6.45153 2.03939 5.62418C2.68461 4.78132 3.44352 3.90168 4.1626 3.1079C4.88296 2.31271 5.5708 1.59582 6.07829 1.07828C6.33223 0.819316 6.54168 0.609916 6.68783 0.464674C6.76091 0.392039 6.81781 0.334839 6.8571 0.296217C6.8767 0.276946 6.89235 0.262368 6.90267 0.252272L6.91895 0.235996C7.24241 -0.0786653 7.75759 -0.0786653 8.08105 0.235996L8.09733 0.252272C8.10765 0.262368 8.1233 0.276946 8.1429 0.296217C8.18219 0.334839 8.23909 0.392039 8.31217 0.464674C8.45832 0.609916 8.66777 0.819316 8.92171 1.07828C9.4292 1.59582 10.117 2.31271 10.8374 3.1079C11.5565 3.90168 12.3154 4.78132 12.9606 5.62418C13.594 6.45153 14.163 7.30008 14.4548 8.02083C14.8067 8.89044 15 9.84035 15 10.8333Z",
          fill: "rgb(var(--skeleton-primary))"
        }
      )
    }
  );
}
export {
  t as DropIcon
};
